export default /* @ngInject */ () => {
	return (val) => {
		const abs = Math.abs(val);
		const float = parseFloat(abs);
		const decimal = float.toFixed(2);
		const format = $.number(decimal, 2, '.', ' ');

		return format;
	};
};
